import { useFormContext } from 'react-hook-form';
import Image from "next/legacy/image";

interface StepThreeProps {
  error?: string;
}

const StepThree: React.FC<StepThreeProps> = ({ error }) => {
  const { register } = useFormContext();

  return (
    <>
      <Image
        src="/images/career-quiz-step-3.svg"
        blurDataURL='/images/career-quiz-step-3.svg'
        layout='responsive'
        loading='eager'
        placeholder='blur'
        width={2500} height={2000}
        alt="Icon of a person sitting at a computer"
        className="self-center block w-32 row-start-1 row-end-3 mx-auto my-2 md:my-0 md:w-44"
      />
      <div className="w-full p-2 md:p-8">
        <h1 className="text-2xl font-semibold text-center text-careerPageHeading md:text-left md:text-3xl">
          What is{' '}
          <span className="text-careerPageHighlight">most important</span> to
          you?
        </h1>
        {error && <p className="mt-4 italic font-semibold text-red">{error}</p>}

        <div className="my-6">
          <div className="relative flex items-center my-4">
            <div className="relative">
              <input
                type="radio"
                id="salary"
                {...register('important')}
                value="salary"
                className="peer opacity-0 z-[100] h-6 w-6 cursor-pointer relative"
              />
              <div className="absolute inset-0 z-10 w-6 h-6 border-2 border-solid rounded-full border-careerPageHeading"></div>
              <div className="absolute inset-0 z-10 hidden w-4 h-4 m-1 rounded-full bg-careerPageHeading peer-checked:block"></div>
            </div>
            <label htmlFor="salary"  className="cursor-pointer">
              <p className="ml-4 text-2xl font-bold text-careerPageHeading">
                Highest wages{' '}
              </p>
              <p className="mb-1 ml-4 text-sm text-careerPageHeading">
                I want to earn as much as I can.{' '}
              </p>
            </label>
          </div>
          <div className="relative flex items-center my-4">
            <div className="relative">
              <input
                type="radio"
                {...register('important')}
                value="brightOutlook"
                id="brightOutlook"
                className="peer opacity-0 z-[100] h-6 w-6 cursor-pointer relative"
              />
              <div className="absolute inset-0 z-10 w-6 h-6 border-2 border-solid rounded-full border-careerPageHeading"></div>
              <div className="absolute inset-0 z-10 hidden w-4 h-4 m-1 rounded-full bg-careerPageHeading peer-checked:block"></div>
            </div>
            <label htmlFor="brightOutlook"  className="cursor-pointer">
              <p className="ml-4 text-2xl font-bold text-careerPageHeading">
                Brightest outlook
              </p>
              <p className="mb-1 ml-4 text-sm text-careerPageHeading">
                I want to join a growing career field.
              </p>
            </label>
          </div>
          <div className="relative flex items-center my-4">
            <div className="relative">
              <input
                type="radio"
                {...register('important')}
                value="fastest"
                id="fastest"
                className="peer opacity-0 z-[100] h-6 w-6 cursor-pointer relative"
              />
              <div className="absolute inset-0 z-10 w-6 h-6 border-2 border-solid rounded-full border-careerPageHeading"></div>
              <div className="absolute inset-0 z-10 hidden w-4 h-4 m-1 rounded-full bg-careerPageHeading peer-checked:block"></div>
            </div>
            <label htmlFor="fastest" className="cursor-pointer">
              <p className="ml-4 text-2xl font-bold text-careerPageHeading">
                Shortest training
              </p>
              <p className="mb-1 ml-4 text-sm text-careerPageHeading">
                I want to enter a new career fast.{' '}
              </p>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepThree;
